import type { SVGProps } from "react";

/**
 * plus-small, add small
 * @category Interface General
 */
export default function IconPlusSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M12 6.75V12M12 12V17.25M12 12H6.75M12 12H17.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}
